import React, { useState } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import '../HomePage.css'; // Import the CSS file
import Login from './UserLogin'

const DashLogin = () => {
  return (
    <>
      <div className="hpTopBanner">
        <span className="hpLogo">Iezloc</span>
        <ul className="hpNavigationMenu">
          {/* <li>Home</li> */}
          <li><NavLink to="/" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Home</NavLink></li>
          <li><NavLink to="/lemma"  className={({ isActive }) => (isActive ? 'activeLink' : '')} >lemma</NavLink></li>
          <li><NavLink to="/login" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Login</NavLink></li>
          <li><NavLink to="/signup" className={({ isActive }) => (isActive ? 'activeLink' : '')}>signup</NavLink></li>
          {/* <li>Contact</li> */}
        </ul>
      </div>
      {Login()}
    </>
  );
}
export default DashLogin;